import { useEffect, useState } from "react";
import api from "../api";

import {
  RefreshCw,
  Trash2,
  AlertTriangle
} from "lucide-react";

export default function OtaSyncDashboard() {

  const [errors, setErrors] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  useEffect(() => {
    fetchErrors();
  }, []);

  // =====================
  // FETCH
  // =====================

  const fetchErrors = async () => {

    try {

      setLoading(true);

      const res =
        await api.get(
          "/ota/sync-errors"
        );

      setErrors(
        res.data || []
      );

    } catch (err) {

      console.error(
        "Erreur chargement OTA",
        err
      );

    } finally {

      setLoading(false);

    }
  };

  // =====================
  // RETRY
  // =====================

  const retrySync = async (id) => {

    try {

      await api.post(
        `/ota/retry/${id}`
      );

      fetchErrors();

    } catch (err) {

      console.error(
        "Erreur retry",
        err
      );

    }
  };

  // =====================
  // DELETE
  // =====================

  const deleteError = async (id) => {

    try {

      await api.delete(
        `/ota/sync-errors/${id}`
      );

      setErrors(
        errors.filter(
          (e) => e.id !== id
        )
      );

    } catch (err) {

      console.error(
        "Erreur suppression",
        err
      );

    }
  };

  // =====================
  // LOADING
  // =====================

  if (loading) {

    return (
      <div className="p-4 md:p-6 bg-gray-100 min-h-[100dvh]">
        Chargement...
      </div>
    );

  }

  // =====================
  // RENDER
  // =====================

  return (
    <div className="p-3 md:p-6 bg-gray-100 min-h-[100dvh]">

      {/* HEADER */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 mb-6">

        <h1 className="text-2xl md:text-3xl font-bold flex items-center gap-2">

          <AlertTriangle className="text-red-500" />

          OTA Sync Monitoring

        </h1>

        <button
          onClick={fetchErrors}
          className="flex items-center justify-center gap-2 bg-blue-600 text-white px-4 py-3 md:py-2 rounded-xl hover:bg-blue-700 transition text-sm md:text-base"
        >

          <RefreshCw size={16} />

          Rafraîchir

        </button>

      </div>

      {/* EMPTY */}
      {errors.length === 0 ? (

        <div className="bg-white rounded-2xl shadow p-4 md:p-6 text-green-600 font-medium">
          🎉 Aucune erreur OTA
        </div>

      ) : (

        <div className="bg-white rounded-2xl shadow overflow-hidden">

          <div className="overflow-x-auto">

            <table className="min-w-[900px] w-full text-sm">

              <thead className="bg-gray-50 text-left">

                <tr>

                  <th className="p-3 whitespace-nowrap">
                    Type
                  </th>

                  <th className="p-3 whitespace-nowrap">
                    Payload
                  </th>

                  <th className="p-3 whitespace-nowrap">
                    Date
                  </th>

                  <th className="p-3 whitespace-nowrap">
                    Actions
                  </th>

                </tr>

              </thead>

              <tbody>

                {errors.map((err) => (

                  <tr
                    key={err.id}
                    className="border-t hover:bg-gray-50 transition"
                  >

                    {/* TYPE */}
                    <td className="p-3 font-medium text-red-600 whitespace-nowrap">
                      {err.type}
                    </td>

                    {/* PAYLOAD */}
                    <td className="p-3 text-xs text-gray-600 max-w-[350px]">

                      <pre className="whitespace-pre-wrap break-words overflow-x-auto">
                        {JSON.stringify(
                          err.payload,
                          null,
                          2
                        )}
                      </pre>

                    </td>

                    {/* DATE */}
                    <td className="p-3 text-gray-500 whitespace-nowrap">
                      {new Date(
                        err.created_at
                      ).toLocaleString()}
                    </td>

                    {/* ACTIONS */}
                    <td className="p-3">

                      <div className="flex flex-col md:flex-row gap-2">

                        {/* RETRY */}
                        <button
                          onClick={() =>
                            retrySync(
                              err.id
                            )
                          }
                          className="flex items-center justify-center gap-1 px-3 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition whitespace-nowrap"
                        >

                          <RefreshCw size={14} />

                          Retry

                        </button>

                        {/* DELETE */}
                        <button
                          onClick={() =>
                            deleteError(
                              err.id
                            )
                          }
                          className="flex items-center justify-center gap-1 px-3 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition whitespace-nowrap"
                        >

                          <Trash2 size={14} />

                          Supprimer

                        </button>

                      </div>

                    </td>

                  </tr>

                ))}

              </tbody>

            </table>

          </div>

        </div>

      )}

    </div>
  );
}